import ForgotPassword from './states/forgotPassword';
import SuggestRegistration from './states/suggestRegistration';
import CheckingEmail from './states/checkingEmail';
import Password from './states/password';
import StartLogin from './states/startLogin';
import LetterSent from './states/letterSent';
import Register from './states/register';
import {
  PASSWORD,
  FORGOT_PASSWORD,
  SUGGESTION,
  CHECKING_EMAIL,
  LETTER_SENT,
  REGISTER,
  START_LOGIN,
  ACCEPT_LEGAL_ISSUES,
  //   REGISTER_SOCIAL,
} from '../../../constants/enter.user.constants';
import acceptLegalIssues from './states/acceptLegalIssues';

class GetState {
  constructor() {
    this.state = null;
  }

  create(type, form, goTo) {
    switch (type) {
      case FORGOT_PASSWORD:
        this.state = new ForgotPassword(form, goTo);
        break;
      case SUGGESTION:
        this.state = new SuggestRegistration(form, goTo);
        break;
      case CHECKING_EMAIL:
        this.state = new CheckingEmail(form, goTo);
        break;
      case PASSWORD:
        this.state = new Password(form, goTo);
        break;
      case LETTER_SENT:
        this.state = new LetterSent(form, goTo);
        break;
      case ACCEPT_LEGAL_ISSUES:
        this.state = new acceptLegalIssues(form, goTo);
        break;
      case REGISTER:
        this.state = new Register(form, goTo);
        break;
      // case REGISTER_SOCIAL:
      //         this.state = new RegisterSocial( form, goTo );
      //         break;
      case START_LOGIN:
      default:
        this.state = new StartLogin(form, goTo);
    }
  }

  getCurrent() {
    return this.state;
  }

  destroy() {
    this.state = null;
  }
}

export default new GetState();
